"use client";

import React, { createContext, ReactNode, useEffect, useState } from "react";

import {
  SidebarContextProps,
  UserHeaderLocalObject,
} from "@/TS/Interfaces/global_interfaces";

export const sidebarContext = createContext<SidebarContextProps>(null!);
function SidebarProvider({ children }: { children: ReactNode }): ReactNode {
  const [val, setVal] = useState<string | ReactNode>("");
  const [jsxValue, setJsxValue] = useState<string | ReactNode>("");
  const [isHide, setIsHide] = useState(false);
  const [panelRef, setPanelRef] =
    useState<SidebarContextProps["panelRef"]>(null);
  const [userHeaderData, setUserHeaderData] =
    useState<UserHeaderLocalObject | null>(null);

  const handleJsx = () => {
    setVal(jsxValue);
  };

  useEffect(() => {
    document.body.style.overflow = "visible";
  }, []);

  useEffect(() => {
    if (val) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  }, [isHide, val]);

  return (
    <sidebarContext.Provider
      value={{
        val,
        setVal,
        isHide,
        setIsHide,
        handleJsx,
        setJsxValue,
        panelRef,
        setPanelRef,
        userHeaderData,
        setUserHeaderData,
      }}
    >
      {children}
    </sidebarContext.Provider>
  );
}

export default SidebarProvider;
